import { AttributeType } from './constant';

/**
 * 属性标注子类型图标统一映射
 *
 * 职责：
 * 1. 作为列表图标与地图覆盖物图标的唯一数据源
 * 2. 为没有独立图标的子类型提供统一兜底（jolt）
 * 3. 避免 OperateList 与 map-core/styles 维护两份重复映射
 */

// 通用图标 key，所有子类型最终映射到这五张基础图
const ATTRIBUTE_ICON_KEY_MAP: Record<AttributeType, string> = {
  [AttributeType.HANGING_BRANCH]: 'branches',
  [AttributeType.BUMPY_ROAD]: 'jolt',
  [AttributeType.DRAIN_COVER]: 'manhole_covers',
  [AttributeType.UPWARD_SLOPE]: 'uphill',
  [AttributeType.DOWNWARD_SLOPE]: 'downhill',
  [AttributeType.INVALID_GATE]: 'jolt',
  [AttributeType.BARRIER_GATE]: 'jolt',
  [AttributeType.UNMANNED_STATION]: 'jolt',
  [AttributeType.INVALID_TRAFFIC_LIGHT]: 'jolt',
  [AttributeType.FENCE]: 'jolt',
  [AttributeType.STOP_FLAG]: 'jolt',
  [AttributeType.PARK]: 'jolt',
  [AttributeType.BACKUP1]: 'jolt',
  [AttributeType.BACKUP2]: 'jolt',
  [AttributeType.INTERSECTION_LIGHT]: 'jolt',
  [AttributeType.INTERSECTION_PASS]: 'jolt',
  [AttributeType.INTERSECTION_TAKEOVER]: 'jolt',
};

const mapIcons: Record<string, string> = {
  branches: require('@/assets/image/mapEditor/map_branches.png'),
  downhill: require('@/assets/image/mapEditor/map_downhill.png'),
  jolt: require('@/assets/image/mapEditor/map_jolt.png'),
  manhole_covers: require('@/assets/image/mapEditor/map_manhole_covers.png'),
  uphill: require('@/assets/image/mapEditor/map_uphill.png'),
};

const listIcons: Record<string, string> = {
  branches: require('@/assets/image/mapEditor/list_branches.png'),
  downhill: require('@/assets/image/mapEditor/list_downhill.png'),
  jolt: require('@/assets/image/mapEditor/list_jolt.png'),
  manhole_covers: require('@/assets/image/mapEditor/list_manhole_covers.png'),
  uphill: require('@/assets/image/mapEditor/list_uphill.png'),
};

/** 获取子类型对应的通用图标 key，未知/空值兜底到 jolt */
export const getAttributeIconKey = (
  subType: AttributeType | string | null | undefined
): string => {
  if (!subType) return 'jolt';
  return ATTRIBUTE_ICON_KEY_MAP[subType as AttributeType] ?? 'jolt';
};

/** 按场景获取图标 URL，未知/空值兜底到 jolt */
export const getAttributeIcon = (
  subType: AttributeType | string | null | undefined,
  context: 'map' | 'list' = 'map'
): string => {
  const key = getAttributeIconKey(subType);
  const icons = context === 'list' ? listIcons : mapIcons;
  return icons[key] ?? icons.jolt;
};


